import { produce } from 'immer';
import {
  ADD_CART_TO_WISHLIST,
  ADD_CART_TO_WISHLIST_FULFILLED,
  ADD_CART_TO_WISHLIST_REJECTED,
  ADD_ITEMS_TO_CART,
  ADD_ITEMS_TO_CART_FULFILLED,
  ADD_ITEMS_TO_CART_REJECTED,
  CLEAR_ADD_CART_TO_WISHLIST,
  CLEAR_ADD_ITEMS_TO_CART,
  CLEAR_CART,
  FETCH_CART,
  FETCH_CART_FULFILLED,
  FETCH_CART_REJECTED,
  REMOVE_CART_FULFILLED,
  REMOVE_VOUCHER,
  REPLACE_CART,
  UPDATE_ITEM_QUANTITY,
  UPDATE_ITEM_REFERENCE,
  UPDATE_VOUCHER,
} from 'b2b-apps/shop/cart/redux/cart/actionTypes';
import { CartActions, CartState } from 'b2b-apps/shop/cart/redux/cart/types';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';

const initialState: CartState = {
  addItems: RemoteRecordData.getDefault(),
  addCartToWishlist: RemoteRecordData.getDefault(),
  cartData: RemoteRecordData.getDefault(),
};

const reducer = (
  state: CartState = initialState,
  action: CartActions,
): CartState => {
  switch (action.type) {
    case ADD_CART_TO_WISHLIST:
      return produce(state, (draft: CartState) => {
        draft.addCartToWishlist = RemoteRecordData.init();
      });

    case ADD_CART_TO_WISHLIST_FULFILLED:
      return produce(state, (draft: CartState) => {
        draft.addCartToWishlist = RemoteRecordData.fulfill(action.payload.data);
      });

    case ADD_CART_TO_WISHLIST_REJECTED:
      return produce(state, (draft: CartState) => {
        draft.addCartToWishlist = RemoteRecordData.reject(action.payload.error);
      });

    case CLEAR_ADD_CART_TO_WISHLIST:
      return produce(state, (draft: CartState) => {
        draft.addCartToWishlist = initialState.addCartToWishlist;
      });

    case CLEAR_CART:
    case REMOVE_CART_FULFILLED:
      return initialState;

    case FETCH_CART:
      return produce(state, (draft: CartState) => {
        draft.cartData = Object.assign(RemoteRecordData.init(), {
          data: draft.cartData.data,
        });
      });

    case FETCH_CART_FULFILLED:
    case REPLACE_CART:
      return produce(state, (draft: CartState) => {
        draft.cartData = RemoteRecordData.fulfill(action.payload.data);
      });

    case FETCH_CART_REJECTED:
      return produce(state, (draft: CartState) => {
        draft.cartData = RemoteRecordData.reject(action.payload.error);
      });

    case REMOVE_VOUCHER:
    case UPDATE_ITEM_QUANTITY:
    case UPDATE_ITEM_REFERENCE:
    case UPDATE_VOUCHER:
      return produce(state, (draft: CartState) => {
        draft.cartData = Object.assign(RemoteRecordData.init(), {
          data: draft.cartData.data,
        });
      });

    case ADD_ITEMS_TO_CART:
      return produce(state, (draft: CartState) => {
        draft.addItems = RemoteRecordData.init();
      });

    case ADD_ITEMS_TO_CART_FULFILLED:
      return produce(state, (draft: CartState) => {
        draft.addItems = RemoteRecordData.fulfill(action.payload.data);
      });

    case ADD_ITEMS_TO_CART_REJECTED:
      return produce(state, (draft: CartState) => {
        draft.addItems = RemoteRecordData.reject(action.payload.error);
      });

    case CLEAR_ADD_ITEMS_TO_CART:
      return produce(state, (draft: CartState) => {
        draft.addItems = initialState.addItems;
      });

    default:
      return state;
  }
};

export { reducer };
